// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_em-2";
export var aiChatCartContainerExit = "_em-4";
export var aiChatContainerLarge = "_em-0";
export var aiChatContainerSmall = "_em-1";
export var aiChatIcon = "_em-6";
export var slideInFromRight = "_em-3";
export var slideOutToRight = "_em-5";